module.exports = __webpack_public_path__ + "static/media/Inter-Italic.6531cc95.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Inter/Inter-Italic.ttf
// module id = 359
// module chunks = 17